<template>
  <v-data-table
    dense
    height="280"
    :headers="detectedAlertsHeader"
    :items="alerts"
    fixed-header
    disable-pagination
    hide-default-footer
    ><template v-slot:[`item.criticity`]="{ item }">
      <v-chip class="mt-1 mb-1 mr-2" :color="item.criticity.color">{{
        item.criticity.name
      }}</v-chip>
    </template>
  </v-data-table>
</template>

<script>
import axios from '../../services/axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import defenseMixin from '../../mixins/defense.js'

Vue.use(VueAxios, axios)

export default {
  name: 'ScreeningCatalogueAlertsTable',

  mixins: [errorMixin, defenseMixin],

  props: {
    alerts: {
      type: Array,
      default: () => []
    }
  },

  components: {},

  mounted() {},

  watch: {},

  data() {
    return { fieldsToDisplay: ['name', 'criticity', 'type'] }
  },

  computed: {
    detectedAlertsHeader() {
      const context = 'AbstractAlertDefinition'
      const headers = this.fieldsToDisplay.map((field) =>
        this.getDescriptionHeaderObjectFromPath([field], context)
      )
      return headers
    }
  },

  methods: {}
}
</script>

<style scoped></style>
